import { useEffect, useState } from "react";
import "./MainEventPage.css";

const MainEventPage = () => {
  const [upcomingEvents, setUpcomingEvents] = useState([]);

  useEffect(() => {
    setUpcomingEvents([
      {
        "id": "1",
        "eventLocation": "Pashupati Nath Temple (Nepal)",
        "eventDate": "Expected 9th May - 12th May",
      },
      {
        "id": "2",
        "eventLocation": "Katak Raj (Pakistan)",
        "eventDate": "30th May - 2nd June",
      },
      {
        "id": "3",
        "eventLocation": "Munneshwaram (Sri Lanka)",
        "eventDate": "27th June - 30th June",
      },
      {
        "id": "4",
        "eventLocation": "Batu Caves (Kuala Lampur)",
        "eventDate": "18th July - 21nd July",
      },
      {
        "id": "5",
        "eventLocation": "Mauritiuses Warnath 12th Jyotirling (East Africa Mauritius)",
        "eventDate": "8th Aug - 11th Aug",
      },
      {
        "id": "6",
        "eventLocation": "Angkar Wat Temple (Combodia)",
        "eventDate": "5th Sept - 8th Sept",
      },
      {
        "id": "7",
        "eventLocation": "United States of America",
        "eventDate": "Not Available Yet",
      },
      {
        "id": "8",
        "eventLocation": "United Kingdom",
        "eventDate": "Not Available Yet",
      },
      {
        "id": "9",
        "eventLocation": "European Country",
        "eventDate": "Not Available Yet",
      },
      {
        "id": "10",
        "eventLocation": "Australia",
        "eventDate": "Not Available Yet",
      },
      {
        "id": "11",
        "eventLocation": "Malaysia",
        "eventDate": "Not Available Yet",
      },
      {
        "id": "12",
        "eventLocation": "Delhi, India",
        "eventDate": "Not Available Yet",
      },
    ]);
  }, []);

  return (
    <>
      <div className="container my-3" style={{overflowX:'hidden'}}>
        <div className="accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <h5>UPCOMING EVENTS</h5>
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <h3
                  className="fw-bold text-center"
                  style={{ color: "rgb(254, 94, 0)" }}
                >
                  IMPC - Bhagva Events
                </h3>
              </div>
              <table className="table table-striped table-bordered">
                <thead className="table-light">
                  <tr>
                    <th>EVENT LOCATION</th>
                    <th>EVENT DATE</th>
                  </tr>
                </thead>
                <tbody>
                  {upcomingEvents.map((item) => (
                    <tr key={item.id}>
                      <td>{item.eventLocation}</td>
                      <td>{item.eventDate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="text-danger text-center fw-bold">NOTE: Stay tuned for more information. We will update the confirmed dates and locations as soon as they are finalized.</div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <h5>PAST EVENTS</h5>
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
               <a className = "text-orange fw-bold" href="/20250418/kailash-kher">IMPC Shiv Shakti Kendra Event | Kailash Kher Concert
               April 18, 2025</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MainEventPage;
